import { useCallback, useEffect, useState } from 'react'

import { ddPanelSubAccountsAPI } from '../api/services/dd_panel_sub_accounts'
import { SubAccount } from '../api/services/dd_panel_sub_accounts/types.ts'
import { useAuth } from '../context/auth'
import { isUserExistsInGroup } from '../utils/userRights.ts'

const useSubAccountDetails = () => {
  const { state } = useAuth()

  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)
  const [subAccount, setSubAccount] = useState<SubAccount | null>(null)
  const [refreshIndex, setRefreshIndex] = useState(0)

    const isMainUser = isUserExistsInGroup(state.groups, 'dd_panel_main_users')

  const refetch = useCallback(() => {
    setRefreshIndex((index) => index + 1)
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ddPanelSubAccountsAPI.getSubAccountDetails()

        if (response.error) {
          setError(response.error)
          setLoading(false)
          return
        }

        const data = response.data

        if (data) {
          setSubAccount(data)
        }
      } catch {
        setError('Something went wrong while fetching pricing data.')
      } finally {
        setLoading(false)
      }
    }

    if (!isMainUser) fetchData()
  }, [refreshIndex])

  return { subAccount, loading, error, refetch }
}
export default useSubAccountDetails
